import { Page } from '@patternfly/react-core'
import * as React from 'react'
import { connect } from 'react-redux'

import * as Auth from '@app/state/authenticate'

import type { ConnectedProps } from 'react-redux';

const mapDispatch = (dispatch) => {
  return {
    logout: () => dispatch(Auth.actions.logout()),
  }
}

const connector = connect(null, mapDispatch)
type PropsFromRedux = ConnectedProps<typeof connector>

class LogoutScreen extends React.Component<PropsFromRedux> {
  componentDidMount() {
    this.props.logout()
  }

  render() {
    return <Page />
  }
}

export default connector(LogoutScreen)
